function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Backbone from '@polleverywhere/backbone';
import _ from 'underscore';
import JsonAPI from './json_api';
import URI from 'urijs';
/*
 * Paginated Collection that can be used directly or inherited.
 */

var PaginatedCollection = /*#__PURE__*/function (_Backbone$Collection) {
  _inheritsLoose(PaginatedCollection, _Backbone$Collection);

  function PaginatedCollection() {
    return _Backbone$Collection.apply(this, arguments) || this;
  }

  var _proto = PaginatedCollection.prototype;

  _proto.initialize = function initialize() {
    this.api = new JsonAPI();
  };

  _proto.nextPage = function nextPage(options) {
    if (options == null) {
      options = {};
    }

    var uri = URI(this.api.links('next'));
    var url = uri.toString().replace(uri.search(), '');

    _.extend(options, {
      url: url,
      data: uri.search(true)
    });

    return this.fetch(options);
  };

  _proto.prevPage = function prevPage(options) {
    if (options == null) {
      options = {};
    }

    var uri = URI(this.api.links('prev'));
    var url = uri.toString().replace(uri.search(), '');

    _.extend(options, {
      url: url,
      data: uri.search(true)
    });

    return this.fetch(options);
  };

  _proto.fetch = function fetch(options) {
    if (options == null) {
      options = {};
    }

    if (options.page) {
      if (!options.data) {
        options.data = {};
      }

      _.extend(options.data, {
        page: options.page
      });
    }

    return _Backbone$Collection.prototype.fetch.call(this, options);
  };

  _proto.currentPage = function currentPage() {
    return this.api.meta('current_page');
  };

  _proto.totalPages = function totalPages() {
    return this.api.meta('total_pages');
  };

  _proto.totalCount = function totalCount() {
    return this.api.meta('total_count');
  };

  _proto.parse = function parse(json, options) {
    this.api.clear({
      silent: true
    });
    this.api.set(json);
    return this.api.data();
  };

  return PaginatedCollection;
}(Backbone.Collection);

export { PaginatedCollection as default };